import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  link: {
    textDecoration: "none",
    color: theme.palette.links,
    "&:hover, &:active, &:visited": {
      color: theme.palette.links,
      textDecoration: "underline"
    }
  }
});

const OSSExternalLink = ({ url, children, classes, className, ...rest }) => (
  <a
    className={[classes.link, className].join(" ")}
    rel="noreferrer noopener"
    target="_blank"
    href={url}
    {...rest}>
    {children}
  </a>
);

export default withStyles(styles)(OSSExternalLink);
